<div class="ac-table flexColumnParent"
     [class.ready]="isHeaderVisible && isBodyVisible"
     [attr.id]="tableId"
     (wheel)="onWheelUpdateHorizontalScroller($event, horizontalScroller)"
     #tableContainer>

    <div class="header-table flexItem" #headerContainer>
        <table [class.visibilityHidden]="!isHeaderVisible || !initialized.isStopped"
               [style.padding-right]="viewportScrollBarWidth | acFunc : widthToPixels"
               (mousedown)="tableMousedown($event)"
               (dblclick)="dblClick($event, container, headerContainer)"
               #headerTable>

            <thead>
            <tr #headerRow>
                <ng-template let-col="col" #defaultHeaderCellTemplate>{{col.title | uppercase}}</ng-template>

                <th *ngFor="let column of _columns"
                    [attr.headers]="column.field"
                    [class.left]="column.stickyLeft"
                    [class.sortable-column]="column.headerSort || sortingMap[column.field]"
                    [class.sortable-column-pointer]="column.headerSort"
                    acChild>

                    <div class="table-cell flexRowParent"
                         (click)="!column.disableSort && column.headerSort && onColumnSort(column)"
                         [style.width]="column.colWidth | acFunc : widthToPixels : minColWidth">
                        <div class="header-table-cell" acLabel #headerCell>
                            <ng-template [acTableCell]="headerCell"
                                         [acTableCellTemplate]="defaultHeaderCellTemplate"
                                         [acTableCellFormatter]="column.titleFormatter"
                                         [acTableCellColumn]="column">
                            </ng-template>
                        </div>

                        <ac-search *ngIf="column.filter as columnFilter"
                                   class="flexItemRowEquals table-column-filter"
                                   [placeHolder]="columnFilter.placeholder"
                                   (click)="$event.stopPropagation()"
                                   (searchChange)="onColumnFilterChanged($event, column)"
                        ></ac-search>

                        <span *ngIf="column.headerSort || sortingMap[column.field]" class="sorter flexItem">
                        <span class="sorter-arrow {{sortingMap[column.field]?.dir}}"></span>
                        <span *ngIf="_sorting.length > 1"
                              class="sorter-order">{{sortingMap[column.field]?.order}}</span>
                    </span>
                    </div>
                    <span class="resize-handle"
                          [class.no-user-selection]="!!(tableCellContextIndex | acFunc: getTableCellContext) || !userSelectState"></span>
                </th>
            </tr>
            </thead>
        </table>
    </div>

    <virtual-scroller class="body-table virtual-scroll flexItemBiggest"
                      [class.visibilityHidden]="!isHeaderVisible || !isBodyVisible"
                      [items]="_rows | acFunc : rowsToViewPortData: collapsedGroups: filters"
                      [enableUnequalChildrenSizes]="true"
                      [bufferAmount]="virtualScrollerBufferAmount"
                      #vsComponent>

        <table [class.no-user-selection]="!userSelectState"
               (mousedown)="tableMousedown($event)"
               (dblclick)="dblClick($event, container, headerContainer)">

            <colgroup>
                <col *ngFor="let column of _columns"
                     [style.width]="column.colWidth | acFunc : widthToPixels : minColWidth">
            </colgroup>
            <!-- #container is saved word for virtual scroller -->
            <tbody #container>

            <tr *ngFor="let row of vsComponent.viewPortItems; let rowIndex=index; trackBy: trackById"
                class="body-table-row"
                [class.selected]="!row._groupId && selection[row.id]"
                [class.odd]="(vsComponent.viewPortInfo.startIndexWithBuffer + rowIndex) % 2 === 1"
                (click)="row._groupId ? toggleGroupCollapsedState(row) : onRowSelect($event, row)">
                <td *ngFor="let column of _columns | acFunc : reduceCells : row; trackBy: trackByField"
                    [attr.headers]="column.field"
                    [attr.colspan]="column | acFunc : getRowColSpan: row"
                    [class.group]="row._groupId"
                    [class.left]="column.stickyLeft"
                    #td>
                    <div class="table-cell body-table-cell" [parentForTitle]="td" acLabel #cell>

                        <ng-template [acTableCellTemplate]="row._groupId ? groupCellTemplate : defaultCellTemplate"
                                     [acTableCell]="cell"
                                     [acTableCellFormatter]="column.formatter"
                                     [acTableCellColumn]="column"
                                     [acTableCellRow]="row">
                        </ng-template>

                    </div>
                </td>
            </tr>

            <ng-template let-row="row" let-col="col" #defaultCellTemplate>
                {{row.data[col.field]?.value || row.data[col.field] || ''}}
            </ng-template>
            <ng-template let-row="row" #groupCellTemplate>
                <ac-svg class="group-collapse"
                        name="expander"
                        [rotate]="row.isCollapsed ? 0 : 45"
                ></ac-svg>
                {{row._groupId + ' (' + groupedRows[row._groupId]?.length + ' items)'}}
            </ng-template>

            </tbody>
        </table>

    </virtual-scroller>

    <div class="flexItem horizontal-scroller"
         (scroll)="updateHorizontalScroll($event, [headerContainer, footerContainer])"
         #horizontalScroller>
        <div class="horizontal-scroller-item"
             [style.width]="headerTable | acFunc : calcHorizontalScrollWidth: viewportScrollBarWidth : headerTableWidthChanges"
        ></div>
    </div>

    <div class="footer-table flexItem" #footerContainer [hidden]="!footer">
        <table *ngIf="footer" [style.padding-right]="viewportScrollBarWidth | acFunc : widthToPixels">

            <tfoot>
            <tr>
                <ng-template let-col="col" #defaultFooterCellTemplate>{{col.title}}</ng-template>
                <th *ngFor="let column of _columns"
                    [class.left]="column.stickyLeft"
                    acChild>

                    <div class="table-cell footer-table-cell"
                         [style.width]="column.colWidth | acFunc : widthToPixels : minColWidth"
                         acLabel
                         #footerCell>
                        <ng-template [acTableCell]="footerCell"
                                     [acTableCellTemplate]="defaultFooterCellTemplate"
                                     [acTableCellFormatter]="column.footerFormatter"
                                     [acTableCellColumn]="column">
                        </ng-template>
                    </div>
                </th>
            </tr>
            </tfoot>
        </table>
    </div>

    <ac-pagination class="flexItem"
                   *ngIf="paginator"
                   [pageIndex]="pageIndex"
                   [pageSize]="pageSize"
                   [itemsDisplayTemplate]="pageItemsDisplayTemplate"
                   [itemsDisplayType]="itemsDisplayType"
                   [pageSelector]="pageSelector"
                   [totalElements]="totalElements"
                   [pageSizeOptions]="pagingSizeOption"
                   (pageIndexChange)="onPageChange($event)"
                   (pageSizeChange)="onPageChange($event)">
    </ac-pagination>

    <ac-progress [hidden]="!loading && (isHeaderVisible || isBodyVisible)" class="ac-table-loader background"
                 [center]="true"></ac-progress>
</div>
